/**
* Created by CHENRC2 on 2018-1-10.
*/
<template>
  <section class='header'>
    <Header :style="{padding: 0}" class="layout-header-bar" style="height:40px;line-height:40px;">
      <ul>
        <li>
          <Icon @click.native="handleToggleClick" :class="rotateIcon"
              :style="{margin: '10px 20px 0',cursor: 'pointer'}"
              type="navicon-round" size="24">
          </Icon>
        </li>
        <li><header-menus /></li>
        <li></li>
        <li class="right"><span style="padding-right:20px;">{{supplierInfoGetter.vendorName}}</span><div style="display:inline-block"><User /></div></li>
        <!-- <li class="right"><Theme /></li> -->
        <!-- <li class="right"><h5>一觉醒来，天都黑了</h5></li> -->
        <!-- <li class="right">
          <Badge count="3">
            <Icon type="ios-bell-outline" size="15" class="message-badge right-icon"></Icon>
          </Badge>
        </li> -->
        <!-- <li class="right">
          <a href="http://evadev.midea.com:5000/frontend/framework/%E5%BF%AB%E9%80%9F%E5%BC%80%E5%A7%8B.html" target="_blank">
            <Icon type="help-circled" size="15" class="right-icon"></Icon>
          </a>
        </li>
        <li class="right"><Icon type="search" size="15" class="right-icon"></Icon></li> -->
      </ul>
    </Header>
  </section>
</template>
<style lang="less" scoped>
@headerHeight: 40px;
.header {
  height: @headerHeight;
  .layout-header-bar {
    background: #fff;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid #dddee1;
    ul {
      list-style-type: none;
      li {
        float: left;
      }
      .right {
        float: right;
        margin-left: 24px;
        .right-icon{
          color: #7f8a9b;
          cursor: pointer;
        }
        .right-icon:hover{
          color: #3aa2eb;
        }
      }
    }
  }
}

</style>
<script>
import User from './components/User.vue';
import HeaderMenus from './components/HeaderMenus.vue';
import { mapGetters } from 'vuex';
// import Theme from './components/Theme.vue';

export default {
  data() {
    return {
      accordionMode: false,
      isCollapsed: true,
    };
  },
  props: ['collapse'],
  methods: {
    handleToggleClick() {
      this.$emit('on-toggle-click', 'default');
    },
  },
  computed: {
    // 折叠左侧菜单
    rotateIcon() {
      return ['menu-icon', this.collapse ? 'rotate-icon' : ''];
    },
        ...mapGetters(['supplierInfoGetter']),
  },
  components: {
    User,
    HeaderMenus,
    // Theme,
  },
  mounted () {
    // this.supplierInfo = JSON.parse(localStorage.getItem('supplierInfo'));
  }
};
</script>
